import { VisualizerFrame } from "./visualizer-frame-container";

export default VisualizerFrame;